export default "__VITE_ASSET__K_d0mjKx__"